import { repository } from '@woc/woc-repository'
import { User, UserCredential, OAuthAuthorization, UserCapabilities } from '@/model/identity'

export const userRepository = repository.create({
  entity: 'user',
  url: 'users',
  allow: 'crule',
  factory: data => new User(data)
})

export const authRepository = repository.create({
  entity: 'currentUser',
  url: 'auth-tokens',
  allow: 'cds',
  childResource: true,
  silent: true,
  factory: data => new User(data)
})

export const capabilitiesRepository = repository.create({
  entity: 'capabilities',
  url: 'users/:userId/capabilities',
  allow: 'rs',
  childResource: true,
  factory: data => new UserCapabilities(data)
})

export const credentialsResetRepository = repository.create({
  entity: 'userCredentialReset',
  url: 'user-credential-resets',
  allow: 'c'
})

export const credentialsRepository = repository.create({
  entity: 'userCredential',
  url: 'user-credentials',
  allow: 'clru',
  factory: data => new UserCredential(data)
})

export const apiKeyRepository = repository.create({
  entity: 'apiKey',
  url: 'users/:userId/api-keys',
  allow: 'c'
})

export const oauthAuthorizationRepository = repository.create({
  entity: 'oauthAuthorization',
  url: 'oauth/authorizations',
  allow: 'cr',
  factory: data => {
    const authorization = new OAuthAuthorization(data)
    authorization.url = `service/oauth/authorizations/${data.correlation_id}`
    return authorization
  }
})

export default repository.asModule(userRepository, authRepository, credentialsResetRepository, credentialsRepository,
  oauthAuthorizationRepository, apiKeyRepository, capabilitiesRepository)

export function identify (store, force) {
  const user = store.state.identity.currentUser
  if (!force && user) {
    if (store.state.identity.capabilities) {
      return Promise.resolve(user)
    } else {
      return store.dispatch(capabilitiesRepository.find, { userId: user.id }).then(() => user, () => user)
    }
  } else {
    return store
      .dispatch(userRepository.find, { id: 'me', transient: true, silent: true })
      .then(user => store.dispatch(capabilitiesRepository.find, { userId: user.id }).then(() => user))
      .then(user => store.dispatch(authRepository.set, { entity: user }))
  }
}

export function signOut (store) {
  return store.dispatch(authRepository.delete, {})
    .then(() => store.dispatch(capabilitiesRepository.set, {}))
}
